import "../../css/custom.css";
import styles from "./ViewCart.module.css";
import React, { useState, useEffect, useRef } from "react";
import {
  Input,
  Row,
  Col,
  Divider,
  Popover,
  Tag,
  Button,
  Badge,
  Checkbox,
  Skeleton,
  Drawer,
  Form,
  Card,
  Radio,
  Modal,
} from "antd";
import {
  RightOutlined,
  MoreOutlined,
  HeartOutlined,
  StarFilled,
  HeartFilled,
  BankOutlined,
  GiftOutlined,
  MinusOutlined,
  PlusOutlined,
  ShoppingCartOutlined,
  PlusCircleOutlined,
  HighlightOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  addBookingInChannel,
  addOrUpdateReseration,
  confirmBookingEnginePayment,
  createBookingEngineOrder,
  getBookingEnginePaymentStatus,
  syncOTAAvailability,
} from "../../redux/HomePage/actionCreater";
import {
  clearSavedOrderId,
  isPaymentFound,
  isReservationCreated,
  PaymentConfirming,
  pollBookingStatus,
  saveOrderId,
} from "./bookingPayment";
import { useNavigate, useParams } from "react-router-dom";
import { getItem, setItem } from "../../utility/localStorageControl";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";
import { useForm } from "antd/es/form/Form";
import moment from "moment";
import { UpOutlined } from "@ant-design/icons";
import footerStlyes from "./footer.module.css";
import { getRoomNightRate } from "./roomPricing";
import {
  criticalPath,
  Price,
  PRICE_COMPONENT,
  PRICE_SUMMARY,
  RootOccupancy,
  STAY_OFFER,
  StayTime,
} from "./hotelAdsMarkup";
const { TextArea } = Input;
function ViewCart(props) {
  const [load, setLoad] = useState(false);
  // { orderId, timedOut } once an online payment went through
  const [confirmingPayment, setConfirmingPayment] = useState(null);
  const unmountedRef = useRef(false);
  useEffect(() => {
    unmountedRef.current = false;
    return () => {
      unmountedRef.current = true;
    };
  }, []);
  let {
    selectedRoomtype,
    numberOfNights,
    rsSymbol,
    setShowBill,
    showBill,
    customerData,
    currentRegisterData,
    reservationStartDate,
    reservationEndDate,
    setReservationData,
    setSelectedRoomType,
    shopDetails,
    reservationDisable,
    showBill1,
    setShowBill1,
    paymentType,
    currency,
    custom_payment,
    color,
    onRemoveRoomType,
  } = props;

  let customerDetails = customerData;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const params = useParams();

  const [totalCalculatedTax, setTotalCalculatedtax] = useState(0);
  const [totalCalculatedPrice, setTotalCalculatedPrice] = useState(0);
  const [totalCalculatedPriceWithoutTax, setTotalCalculatedPriceWihoutTax] =
    useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [windowWidth, setWindowWidth] = useState(
    window.innerWidth > 0 ? window.innerWidth : window.outerWidth,
  );
  useEffect(() => {
    setWindowWidth(
      window.innerWidth > 0 ? window.innerWidth : window.outerWidth,
    );
  }, [window.innerWidth > 0 ? window.innerWidth : window.outerWidth]);
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  useEffect(() => {
    setLoad(false);
  }, [customerData]);

  const calCulatedTaxPriceofThisRoomType = (
    totalPrice,
    taxes,
    checkIsInclusive,
  ) => {
    let totalTax = 0;
    let inclusiveTax = 0;
    let totalTaxPercent = 0;
    taxes?.map((val) => {
      if (checkIsInclusive != "remove") {
        totalTaxPercent += Number(val.tax_percentage);
      }
    });
    if (checkIsInclusive == true) {
      totalTax = calculateTaxInclusive(totalPrice, totalTaxPercent).taxAmount;
      inclusiveTax = totalTax;
    } else if (checkIsInclusive == false) {
      totalTax = (totalPrice * totalTaxPercent) / 100;
    }
    inclusiveTax = parseFloat(inclusiveTax.toFixed(2));
    totalTax = parseFloat(totalTax.toFixed(2));
    return { totalTax, inclusiveTax };
  };
  function calculateTaxInclusive(totalAmount, taxRate) {
    taxRate = taxRate / 100;
    var originalAmount = totalAmount / (1 + taxRate);
    var taxAmount = totalAmount - originalAmount;
    return {
      originalAmount: originalAmount,
      taxAmount: taxAmount,
    };
  }
  const calculatedPriceOfThisRoomType = (selectRoomType) => {
    if (selectRoomType.room_type.name != "") {
      let totalPrice = 0;
      let totalTaxPrice = 0;
      let totalGuest = 0;

      selectRoomType.rooms?.map((val) => {
        // same per-night formula the room cards use (roomPricing.js)
        let oneRoomCalCulatedPrice =
          numberOfNights * getRoomNightRate(selectRoomType, val);

        totalPrice = totalPrice + oneRoomCalCulatedPrice;
        totalGuest = val.adults + val.children + val.infants;
      });

      let { totalTax, inclusiveTax } = calCulatedTaxPriceofThisRoomType(
        totalPrice,
        selectRoomType.room_type.tax_group.taxes,
        selectRoomType.room_type.tax_group.taxes_inclusive_in_product_price,
      );
      selectRoomType["calculatedPriceWithoutTax"] = totalPrice - inclusiveTax;

      totalTaxPrice = totalTax;
      selectRoomType["calCulatedTaxPrice"] = totalTaxPrice;
      selectRoomType["calCulatedInclusiveTaxPrice"] = inclusiveTax;
      totalPrice = totalPrice + totalTaxPrice - inclusiveTax;
      selectRoomType["calculatedPriceWithTax"] = totalPrice;
      selectRoomType["total_guest"] = totalGuest;
      return selectRoomType;
    }
  };
  useEffect(() => {
    let finalTotalPrice = 0;
    let finalTaxPrice = 0;
    let finalTotalPriceWithoutPrice = 0;

    selectedRoomtype?.map((roomType) => {
      if (roomType.room_type.name != "" && roomType.numberOfRooms > 0) {
        let oneRoomType = calculatedPriceOfThisRoomType(roomType);
        finalTotalPrice = finalTotalPrice + oneRoomType.calculatedPriceWithTax;
        finalTotalPriceWithoutPrice =
          finalTotalPriceWithoutPrice + oneRoomType?.calculatedPriceWithoutTax;
        finalTaxPrice = finalTaxPrice + oneRoomType.calCulatedTaxPrice;
      }
    });
    setTotalCalculatedPriceWihoutTax(finalTotalPriceWithoutPrice);
    setTotalCalculatedPrice(finalTotalPrice);
    setTotalCalculatedtax(finalTaxPrice);
  }, [selectedRoomtype, numberOfNights]);
  const handleSelectRoomType = (selectedRoomtype) => {
    let array = selectedRoomtype.map((val) => {
      if (val?.room_type?.rate_plan_list?.length) {
        let findIndex = val.room_type.rate_plan_list.findIndex(
          (k) => k.rate_id == val.rate_plan.rate_id,
        );
        if (findIndex != -1) {
          val.room_type.rate_plan_list[findIndex] = val.rate_plan;
        }
        return val;
      } else {
        return val;
      }
    });
    return array;
  };
  const createReservationDetails = async (advanceAmount) => {
    let formData = {};
    if (currentRegisterData) {
      formData["prefix"] = currentRegisterData.receipt_number_prefix;
      formData["customer"] = customerDetails;
      formData["reservationInDate"] =
        moment(reservationStartDate).format("YYYY-MM-DD");
      formData["reservationOutDate"] =
        moment(reservationEndDate).format("YYYY-MM-DD");
      console.log("reservationStartDate", reservationStartDate);
      let startObject = new Date(reservationStartDate);
      startObject.setHours(12, 30, 0, 0);
      let endObject = new Date(reservationEndDate);
      endObject.setHours(12, 30, 0, 0);
      formData["register_id"] = currentRegisterData?._id;
      formData["register_data"] = {
        _id: currentRegisterData?._id,
        subscription_status: currentRegisterData.subscription_status,
        user_id: currentRegisterData?.user_id,
        main_register_id: currentRegisterData?.register_id,
        shop_name: shopDetails?.shop_name,
        voucher_footer: currentRegisterData?.voucher_footer,
        bill_header: currentRegisterData?.bill_header,
        booking_notification_email:
          currentRegisterData?.booking_notification_email,
      };
      formData["reservationInDateAndTime"] = startObject;
      formData["reservationOutDateAndTime"] = endObject;
      formData["totalNights"] = numberOfNights;
      formData["roomTypes"] = handleSelectRoomType(selectedRoomtype);
      formData["quickReservation"] = false;
      formData["reservationInTime"] = "12:30 pm";
      formData["reservationOutTime"] = "12:30 pm";
      formData["general"] = {
        source: "OTA",
        channel: "Booking Engine",
      };
      // formData["reservationCreatedStaffUserIyd"] = 152;
      // formData["reservationUpdateStaffUserId"] = 45;
      formData["reservationBookTime"] = new Date();
      formData["reservationUpdateTime"] = new Date();
      formData["advanceAmount"] = advanceAmount;
      let paymentObj = {
        discount: 0,
        roomCharges: totalCalculatedPriceWithoutTax,
        roomChargesTax: totalCalculatedTax,
        grandTotal: totalCalculatedPrice,
        currency: rsSymbol,
        extraCharges: 0,
        received: advanceAmount ? advanceAmount : 0,
      };

      formData["payment"] = paymentObj;
      if (customerData?.additional && customerData?.additional != "") {
        formData["notes"] = [
          {
            createAt: new Date(),
            updateAt: new Date(),
            text: customerData?.additional,
            important: true,
            delete: false,
            notesUserName: "Customer",
          },
        ];
      }
    }

    return formData;
  };
  const createChannelPayload = (payload, reservationData) => {
    let roomsStays = [];
    let age10Geuset = 0;
    let age08Geuset = 0;
    payload?.roomTypes?.map((k) => {
      age10Geuset = age10Geuset + k.rooms[0].adults;
      age08Geuset = age08Geuset + k.rooms[0].children;
      if (k.numberOfRooms > 1) {
        for (let i = 0; i < k.numberOfRooms; i++) {
          let calculatedPriceWithoutTax =
            k.calculatedPriceWithoutTax / k.numberOfRooms;
          let calculatedPriceWithTax =
            k?.calculatedPriceWithTax / k.numberOfRooms;
          roomsStays.push({
            RoomTypes: [
              {
                RoomDescription: {
                  Name: k?.room_type?.channel_room_name,
                },
                NumberOfUnits: 1,
                RoomTypeCode: k?.room_type?.channel_room_code,
              },
            ],
            RatePlans: [
              {
                RatePlanCode:
                  k?.rate_plan?.channel_rate_obj?.PropertyRatePlanCode,
                RatePlanName:
                  k?.rate_plan?.channel_rate_obj?.PropertyRatePlanName,
              },
            ],
            GuestCounts: [
              {
                AgeQualifyingCode: "10",
                Count: k?.rooms[0]?.adults?.toString(),
              },
              {
                AgeQualifyingCode: "8",
                Count: k?.rooms[0]?.children?.toString(),
              },
            ],
            TimeSpan: {
              Start: payload?.reservationInDate,
              End: payload?.reservationOutDate,
            },
            RoomRates: createRoomRates(
              payload?.reservationInDate,
              payload?.reservationOutDate,
              calculatedPriceWithoutTax / payload?.totalNights,
              calculatedPriceWithTax / payload?.totalNights,
            ),
            Total: {
              AmountBeforeTax: Number(calculatedPriceWithoutTax?.toFixed(2)),
              AmountAfterTax: Number(calculatedPriceWithTax?.toFixed(2)),
              CurrencyCode: currency,
            },
          });
        }
      } else {
        roomsStays.push({
          RoomTypes: [
            {
              RoomDescription: {
                Name: k?.room_type?.channel_room_name,
              },
              NumberOfUnits: k.numberOfRooms,
              RoomTypeCode: k?.room_type?.channel_room_code,
            },
          ],
          RatePlans: [
            {
              RatePlanCode:
                k?.rate_plan?.channel_rate_obj?.PropertyRatePlanCode,
              RatePlanName:
                k?.rate_plan?.channel_rate_obj?.PropertyRatePlanName,
            },
          ],
          GuestCounts: [
            {
              AgeQualifyingCode: "10",
              Count: k?.rooms[0]?.adults?.toString(),
            },
            {
              AgeQualifyingCode: "8",
              Count: k?.rooms[0]?.children?.toString(),
            },
          ],
          TimeSpan: {
            Start: payload?.reservationInDate,
            End: payload?.reservationOutDate,
          },
          RoomRates: createRoomRates(
            payload?.reservationInDate,
            payload?.reservationOutDate,
            k?.calculatedPriceWithoutTax / payload?.totalNights,
            k?.calculatedPriceWithTax / payload?.totalNights,
          ),
          Total: {
            AmountBeforeTax: Number(k?.calculatedPriceWithoutTax?.toFixed(2)),
            AmountAfterTax: Number(k?.calculatedPriceWithTax?.toFixed(2)),
            CurrencyCode: currency,
          },
        });
      }
    });

    let channelPayload = {
      RoomStays: roomsStays,
      ResGuests: [
        {
          Customer: {
            PersonName: {
              NamePrefix: "Mr",
              GivenName: payload?.customer?.name,
              Surname: "",
            },
            Telephone: {
              PhoneNumber: payload?.customer?.mobile,
            },
            Email: payload?.customer?.email,
            Address: {
              AddressLine: [payload?.customer?.shipping_address],
              CityName: "",
              PostalCode: "",
              StateProv: "",
              CountryName: "",
            },
          },
          PrimaryIndicator: "1",
        },
      ],
      ResGlobalInfo: {
        UniqueID: {
          ID: reservationData?._id,
        },
        BasicPropertyInfo: {
          HotelCode: currentRegisterData?.ota_hotel_code,
          HotelName: shopDetails?.shop_name,
        },
        Source: {
          RequestorID: {
            ID: "Posease",
            Type: "ChannelManager",
          },
          BookingChannel: {
            Type: "OTA",
            CompanyName: "Posease",
            CompanyCode: "",
          },
        },
        CreateDateTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
        ResStatus: "Commit",
        TimeSpan: {
          Start: payload?.reservationInDate,
          End: payload?.reservationOutDate,
        },
        GuestCounts: [
          {
            AgeQualifyingCode: "10",
            Count: age10Geuset,
          },
          {
            AgeQualifyingCode: "8",
            Count: age08Geuset,
          },
        ],
        Total: {
          Taxes: {
            Tax: {
              Amount: payload?.payment?.roomChargesTax,
              CurrencyCode: currency,
            },
          },
          AmountBeforeTax: Number(
            Number(
              payload?.payment?.grandTotal - payload?.payment?.roomChargesTax,
            ).toFixed(2),
          ),
          CurrencyCode: currency,
          AmountAfterTax: Number(payload?.payment?.grandTotal.toFixed(2)),
        },
        PaymentTypeInfo: {
          PaymentType: "PayAtHotel",
        },
        SpecialRequests: [""],
      },
    };
    return channelPayload;
  };
  const createRoomRates = (startDate1, endDate1, beforeTax, afterTax) => {
    let startdate = startDate1;
    let endDate = endDate1;
    let RoomRates = [];
    let currentDate = new Date(startdate);
    let end = new Date(endDate);
    while (currentDate < end) {
      RoomRates.push({
        Base: {
          AmountBeforeTax: Number(beforeTax?.toFixed(2)),
          AmountAfterTax: Number(afterTax?.toFixed(2)),
          CurrencyCode: currency,
        },
        EffectiveDate: currentDate.toISOString().split("T")[0], // format as "YYYY-MM-DD"
      });
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return RoomRates;
  };
  // push a new reservation to the eGlobe channel manager
  const pushReservationToChannel = async (payload, reservation) => {
    if (
      currentRegisterData?.connect_channel &&
      currentRegisterData?.channel_key != ""
    ) {
      let channelPayload = createChannelPayload(payload, reservation);
      if (currentRegisterData?.ota_token) {
        channelPayload["ota_token"] = currentRegisterData?.ota_token;
      }
      if (channelPayload) {
        let channelResponse = await dispatch(
          addBookingInChannel(channelPayload),
        );

        if (channelResponse && channelResponse?.data?.IsSuccess) {
        } else if (channelResponse && channelResponse?.data) {
          message.error({
            content: channelResponse?.data?.Message,
            style: {
              float: "center",
              marginTop: "2vh",
              duration: 5,
            },
          });
        }
      }
      // refresh OTA availability on eGlobe for the booked nights
      dispatch(
        syncOTAAvailability(
          currentRegisterData,
          payload?.roomTypes
            ?.filter((k) => Number(k?.numberOfRooms) > 0)
            .map((k) => ({
              room_type: k.room_type,
              reservationInDateAndTime: payload.reservationInDateAndTime,
              reservationOutDateAndTime: payload.reservationOutDateAndTime,
            })),
        ),
      );
    }
  };
  const showConfirmed = (reservation) => {
    setShowBill(false);
    setShowBill1(false);
    setSelectedRoomType([]);
    setReservationData(reservation);
  };
  // pay at hotel only, online payments are booked by the server
  const submitReservation = async (advanceAmount) => {
    let payload = await createReservationDetails(advanceAmount);

    if (payload == true) {
      // setReservationDisable(false);
      return true;
    }
    const getReservation = await dispatch(addOrUpdateReseration(payload));
    if (getReservation && getReservation?.data) {
      await pushReservationToChannel(payload, getReservation.data);
      showConfirmed(getReservation?.data);
      // window.location.reload();
    }
    setLoad(false);
  };
  // the paid reservation exists: same success path as submitReservation
  const finishPaidBooking = async (reservation, bookingPayload) => {
    clearSavedOrderId();
    try {
      await pushReservationToChannel(bookingPayload, reservation);
    } catch (err) {
      // the guest has paid and is booked, a failed OTA push must not hide that
      console.log("pushReservationToChannel error", err);
    }
    showConfirmed(reservation);
  };
  // guest has paid but the reservation is not there yet: keep asking the
  // server, never offer "Pay Now" again
  const waitForPaidBooking = async (orderId, bookingPayload) => {
    setConfirmingPayment({ orderId });
    const result = await pollBookingStatus({
      dispatch,
      orderId,
      isCancelled: () => unmountedRef.current,
    });
    if (result.cancelled) return;
    if (result.reservation) {
      await finishPaidBooking(result.reservation, bookingPayload);
      return;
    }
    if (result.notFound) clearSavedOrderId();
    // timed out: the webhook / a reopened tab will finish it, so the
    // order id stays saved
    setConfirmingPayment({ orderId, timedOut: true });
  };
  // confirm / status result after the guest has paid
  const handlePaidBookingResult = async (response, orderId, bookingPayload) => {
    if (isReservationCreated(response)) {
      await finishPaidBooking(response.data, bookingPayload);
    } else {
      await waitForPaidBooking(orderId, bookingPayload);
    }
  };
  const handlePayment = async (body) => {
    if (customerDetails.name == undefined || customerDetails.name == "") {
      message.error("Enter Your Name");
      return true;
    }
    if (customerDetails.email == undefined || customerDetails.email == "") {
      message.error("Enter Your Email");
      return true;
    }
    if (customerDetails.mobile == undefined || customerDetails.mobile == "") {
      message.error("Enter Your Phone");
      return true;
    }
    setLoad(true);
    if (paymentType == "pay_at_hotel") {
      await submitReservation();
      return true;
    }
    let advanceAmount = 0;
    if (paymentType == "custom") {
      advanceAmount = (Number(custom_payment) / 100) * totalCalculatedPrice;
    } else if (paymentType == "pay_at_user") {
      advanceAmount = body.amount;
    }
    if (!window.Razorpay) {
      message.error("Payment could not load, please refresh");
      setLoad(false);
      return true;
    }
    let savedOrderId = null;
    try {
      // the server stores this booking before Checkout opens and books it
      // itself (confirm / status / webhook) once the order is paid
      const bookingPayload = await createReservationDetails(advanceAmount);
      const order = await dispatch(
        createBookingEngineOrder({
          register_id: currentRegisterData?._id,
          bookingPayload,
        }),
      );
      if (!order?.data?.order_id) {
        // error bodies / network errors are already toasted by the
        // DataService interceptor
        if (order && !order.error) {
          message.error("Could not start payment, please try again");
        }
        setLoad(false);
        return true;
      }
      const { order_id, key_id, amount } = order.data;
      const options = {
        key: key_id,
        amount: amount,
        currency: order.data.currency,
        name: shopDetails?.shop_name,
        description: shopDetails?.shop_name,
        order_id: order_id,
        handler: async function (response) {
          setConfirmingPayment({ orderId: order_id });
          const result = await dispatch(
            confirmBookingEnginePayment({
              razorpay_order_id: response?.razorpay_order_id,
              razorpay_payment_id: response?.razorpay_payment_id,
              razorpay_signature: response?.razorpay_signature,
            }),
          );
          await handlePaidBookingResult(result, order_id, bookingPayload);
        },
        prefill: {
          name: customerData?.name,
          email: customerData?.email,
          contact: customerData?.mobile,
        },
        theme: {
          color: color,
        },
        modal: {
          escape: false,
          ondismiss: async function () {
            // closed without the handler firing: the guest may still have
            // paid (e.g. UPI), so ask the server once before resetting
            const status = await dispatch(
              getBookingEnginePaymentStatus(order_id),
            );
            if (isReservationCreated(status) || isPaymentFound(status)) {
              await handlePaidBookingResult(status, order_id, bookingPayload);
            } else {
              clearSavedOrderId();
              setLoad(false);
            }
          },
        },
      };
      const rzp = new window.Razorpay(options);
      // Checkout shows its own retry, the popup stays open
      rzp.on("payment.failed", function (response) {
        message.error(
          response?.error?.description || "Payment failed, please try again",
        );
      });
      savedOrderId = order_id;
      saveOrderId(order_id);
      rzp.open();
    } catch (err) {
      console.log("handlePayment error", err);
      if (savedOrderId) clearSavedOrderId();
      message.error("Could not start payment, please try again");
      setLoad(false);
    }
  };
  const checkInLabel = moment(reservationStartDate).format("ddd, DD MMM YYYY");
  const checkOutLabel = moment(reservationEndDate).format("ddd, DD MMM YYYY");
  // "Proceed" is the crawler's 2nd click; "Complete Reservation" / "Pay Now"
  // on the final stage must never be one, or the bot would book
  const proceedPath = showBill ? {} : criticalPath(2);
  const priceCurrency = currency || "INR";
  const formatAmount = (amount) => Number(amount || 0).toFixed(2);

  // selected rooms in Booking Details (desktop) and the Price Summary modal
  // (phones). Remove is hidden on the guest-details step, where "Change your
  // selection" is the way back. `tagMicrodata` only on the desktop card so the
  // Hotel Ads occupancy tags are not duplicated.
  const canRemoveRooms = !showBill && typeof onRemoveRoomType === "function";
  const renderCartItems = (tagMicrodata) => (
    <div className={styles.cartItemList}>
      {selectedRoomtype?.map((val, index) => {
        const roomLabel = `${val?.room_type?.name || "Room"}${
          val?.rate_plan?.rate_name ? ` · ${val.rate_plan.rate_name}` : ""
        }`;
        return (
          <div
            className={styles.cartItem}
            key={`${val?.roomTypeId}-${val?.rate_plan?.rate_id}-${index}`}
          >
            <div className={styles.cartItemInfo}>
              <div className={styles.cartItemName}>
                <span className={styles.cartItemQty}>
                  {val.numberOfRooms} ×
                </span>{" "}
                {roomLabel}
              </div>
              {val.rooms.map((k, i) => {
                // the crawler books one room: its guests are the
                // occupancy Google checks against the search
                const tagGuests = tagMicrodata && showBill && index === 0 && i === 0;
                return (
                  <div className={styles.cartItemGuests} key={i}>
                    {val.rooms.length > 1 && (
                      <span className={styles.cartItemRoomNo}>
                        Room {i + 1}:{" "}
                      </span>
                    )}
                    <span itemProp={tagGuests ? "numAdults" : undefined}>
                      {k.adults}
                    </span>{" "}
                    Adult ·{" "}
                    <span itemProp={tagGuests ? "numChildren" : undefined}>
                      {k.children}
                    </span>{" "}
                    Children · {k.infants} Infant
                  </div>
                );
              })}
            </div>
            <div className={styles.cartItemSide}>
              <div className={styles.cartItemPrice}>
                {rsSymbol}
                {formatAmount(val.calculatedPriceWithoutTax)}
              </div>
              {canRemoveRooms && (
                <button
                  type="button"
                  className={styles.removeRoomBtn}
                  onClick={() => onRemoveRoomType(val)}
                  aria-label={`Remove ${roomLabel}`}
                  title="Remove room"
                >
                  <i className="fa-regular fa-trash-can" aria-hidden="true"></i>
                </button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );

  // part payment: the hotel takes custom_payment % now, the rest at the
  // hotel. 0 % or 100 % is not an advance, so the card stays hidden.
  const advancePercent = Number(Number(custom_payment || 0).toFixed(2));
  const hasAdvance =
    paymentType == "custom" && advancePercent > 0 && advancePercent < 100;
  // same formula handlePayment charges, rounded to paise for display
  const payNowAmount = hasAdvance
    ? Math.round(advancePercent * totalCalculatedPrice) / 100
    : 0;
  const balanceAmount = totalCalculatedPrice - payNowAmount;

  // compact = mobile footer button, where the full label does not fit
  const getActionLabel = (compact) => {
    if (confirmingPayment) return "Confirming...";
    if (load) return "Loading...";
    if (!showBill) return "Proceed";
    if (paymentType == "pay_at_hotel") return "Complete Reservation";
    if (hasAdvance) {
      return compact
        ? "Pay Advance"
        : `Pay ${rsSymbol}${formatAmount(payNowAmount)} Advance`;
    }
    return "Pay Now";
  };

  // own --text-color: the mobile price modal renders outside the card
  const renderAdvanceCard = () =>
    hasAdvance ? (
      <div className={styles.advanceCard} style={{ "--text-color": color }}>
        <div className={styles.advanceNote}>
          <InfoCircleOutlined className={styles.advanceIcon} />
          <span>
            This hotel requires a {advancePercent}% advance to confirm
          </span>
        </div>
        <div className={styles.advanceRow}>
          <span>Pay now ({advancePercent}% advance)</span>
          <span className={styles.advanceAmount}>
            {rsSymbol}
            {formatAmount(payNowAmount)}
          </span>
        </div>
        <div className={`${styles.advanceRow} ${styles.advanceBalance}`}>
          <span>Balance payable at hotel</span>
          <span className={styles.advanceAmount}>
            {rsSymbol}
            {formatAmount(balanceAmount)}
          </span>
        </div>
      </div>
    ) : null;
  return (
    <div>
      {confirmingPayment && (
        <PaymentConfirming
          orderId={confirmingPayment.orderId}
          timedOut={confirmingPayment.timedOut}
        />
      )}
      <div>
        {windowWidth <= 800 ? (
          <div>
            <div
              className={footerStlyes.pageFooter}
              style={{ "--text-color": color }}
            >
              {1 ? (
                <div className={footerStlyes.viewCartDetailFooter}>
                  <div className={footerStlyes.cartItems} onClick={showModal}>
                    <div className={footerStlyes.cartAmount}>
                      <p>
                        {rsSymbol}
                        {Number(totalCalculatedPrice).toFixed(2)}
                      </p>
                      {hasAdvance && (
                        <small>
                          Pay {rsSymbol}
                          {formatAmount(payNowAmount)} now ({advancePercent}%
                          advance)
                        </small>
                      )}
                    </div>
                    <UpOutlined className={footerStlyes.cartIcon} />
                  </div>
                  <div className={footerStlyes.cartDetailBtn}>
                    <button
                      {...proceedPath}
                      onClick={() => {
                        if (selectedRoomtype?.length == 0) {
                          message.error("Please Add Room");
                          return true;
                        }
                        if (reservationDisable) {
                          message.error(
                            " Selected rooms are currently occupied for this category. Please wait for availability or consider offering alternative category.",
                          );
                          return true;
                        }
                        if (!showBill) {
                          setShowBill(true);
                          setShowBill1(true);
                        } else {
                          if (load == false && !confirmingPayment) {
                            setLoad(true);
                            // submitReservation();
                            handlePayment({
                              amount: Number(totalCalculatedPrice).toFixed(2),
                            });
                          }
                        }
                      }}
                    >
                      <a href="#" style={{ color: "white" }}>
                        {getActionLabel(true)}
                      </a>
                    </button>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <Modal
              className={`modalPayNow ${styles.modalPayNow}`}
              title={<b>Price Summary</b>}
              visible={isModalVisible}
              onOk={handleOk}
              onCancel={handleCancel}
            >
              <div className={styles.modalRoomList}>{renderCartItems(false)}</div>
              <div className={styles.modalPayable}>
                <div className="d-flex justify-content-between ">
                  <div className="d-flex flex-column">
                    <h3>Room Total</h3>
                  </div>
                  <div className="d-flex flex-column">
                    <h3>
                      {rsSymbol}
                      {Number(totalCalculatedPriceWithoutTax).toFixed(2)}
                    </h3>
                  </div>
                </div>
                <div className="d-flex justify-content-between ">
                  <div className="d-flex flex-column">
                    <h3>Tax</h3>
                  </div>
                  <div className="d-flex flex-column">
                    <h3>
                      {rsSymbol}
                      {Number(totalCalculatedTax).toFixed(2)}
                    </h3>
                  </div>
                </div>
              </div>
              <div
                className={`d-flex justify-content-between ${styles.totalPay}`}
              >
                <h3>Total price (incl. taxes)</h3>
                <h3>
                  {rsSymbol}
                  {Number(totalCalculatedPrice).toFixed(2)}
                </h3>
              </div>
              {hasAdvance && (
                <div className={styles.advanceModalWrap}>
                  {renderAdvanceCard()}
                </div>
              )}
            </Modal>
          </div>
        ) : null}
      </div>
      {/* same room as the tagGuests row below, on the root reservation */}
      {showBill && (
        <RootOccupancy
          numAdults={selectedRoomtype?.[0]?.rooms?.[0]?.adults}
          numChildren={selectedRoomtype?.[0]?.rooms?.[0]?.children}
        />
      )}
      {windowWidth > 800 || showBill ? (
        <div
          style={{ "--text-color": color }}
          className={styles.cardPayDetails}
          {...(showBill ? STAY_OFFER : {})}
        >
          <h2>Booking Details</h2>
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex flex-column">
              <h3>Check-in</h3>
              <p>
                {showBill ? (
                  <StayTime itemProp="checkinTime" date={reservationStartDate}>
                    {checkInLabel}
                  </StayTime>
                ) : (
                  checkInLabel
                )}
              </p>
            </div>
            <div className={styles.oneN}>{numberOfNights}N</div>
            <div className="d-flex flex-column">
              <h3 style={{ textAlign: " right" }}>Check-out</h3>
              <p style={{ textAlign: " right" }}>
                {showBill ? (
                  <StayTime itemProp="checkoutTime" date={reservationEndDate}>
                    {checkOutLabel}
                  </StayTime>
                ) : (
                  checkOutLabel
                )}
              </p>
            </div>
          </div>
          <hr />
          <div className={styles.cartItemsWrap}>{renderCartItems(true)}</div>
          {showBill && (
            <p
              style={{
                color: "rgb(0 127 255)",
                textAlign: "center",
                fontSize: "16px",
                fontWeight: 600,
                marginBottom: "2px",
                cursor: "pointer",
              }}
              onClick={() => {
                setShowBill(false);
                setShowBill1(false);
              }}
            >
              Change your selection
            </p>
          )}

          <label>Price Summary</label>
          <hr />
          {/* on the final stage this is the price Hotel Ads checks: the
              total plus its Room Total / Tax breakdown */}
          <div
            className={styles.priceSummary}
            {...(showBill ? PRICE_SUMMARY : {})}
          >
            <div className={styles.priceRows}>
              <div
                className="d-flex justify-content-between "
                {...(showBill ? PRICE_COMPONENT : {})}
              >
                <div className="d-flex flex-column">
                  <h3 itemProp={showBill ? "name" : undefined}>Room Total</h3>
                </div>
                <div className="d-flex flex-column">
                  <h3>
                    <Price
                      symbol={rsSymbol}
                      amount={totalCalculatedPriceWithoutTax}
                      currency={priceCurrency}
                      markup={showBill}
                    />
                  </h3>
                </div>
              </div>
              <div
                className="d-flex justify-content-between "
                {...(showBill ? PRICE_COMPONENT : {})}
              >
                <div className="d-flex flex-column">
                  <h3 itemProp={showBill ? "name" : undefined}>Tax</h3>
                </div>
                <div className="d-flex flex-column">
                  <h3>
                    <Price
                      symbol={rsSymbol}
                      amount={totalCalculatedTax}
                      currency={priceCurrency}
                      markup={showBill}
                    />
                  </h3>
                </div>
              </div>
            </div>
            <div
              className={`d-flex justify-content-between ${styles.totalPay}`}
            >
              <h3>Total price (incl. taxes)</h3>
              <h3>
                <Price
                  symbol={rsSymbol}
                  amount={totalCalculatedPrice}
                  currency={priceCurrency}
                  markup={showBill}
                />
              </h3>
            </div>
          </div>
          {hasAdvance && (
            <div className={styles.advanceWrap}>{renderAdvanceCard()}</div>
          )}
          {windowWidth > 800 && (
            <div
              className="d-flex justify-content-center"
              style={{ marginTop: "10px" }}
            >
              <a
                href="#"
                {...proceedPath}
                onClick={() => {
                  if (selectedRoomtype?.length == 0) {
                    message.error("Please Add Room");
                    return true;
                  }
                  if (reservationDisable) {
                    message.error(
                      " Selected rooms are currently occupied for this category. Please wait for availability or consider offering alternative category.",
                    );
                    return true;
                  }
                  if (!showBill) {
                    setShowBill(true);
                    setShowBill1(true);
                  } else {
                    if (load == false && !confirmingPayment) {
                      // submitReservation();
                      handlePayment({
                        amount: Number(totalCalculatedPrice).toFixed(2),
                      });
                    }
                  }
                }}
              >
                {getActionLabel(false)}
              </a>
            </div>
          )}

          <div>
            <div
              className={`d-flex flex-column justify-content-between ${styles.guarantedMsg}`}
            >
              <h5>Lowest price guaranteed</h5>
              <p>
                You will get the lowest room price on our platform compared to
                others. We guarantee it.
              </p>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default ViewCart;
